import { pushItemNotFoundEvent } from '@/utils/avoGtm.utils';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export function useGoogleEvents(predicate, handleEvent = pushItemNotFoundEvent) {
  const router = useRouter();
  const isGoogleFlights = +router.query?.googleFlights === 1;
  useEffect(() => {
    if (predicate && isGoogleFlights) {
      handleEvent();
    }
  }, [predicate, isGoogleFlights]);
}
